<div class="container-fluid">
  <div class="row">
    <p-table
      #dt
      dataKey="id"
      [value]="gridItems"
      [lazy]="true"
      selectionMode="single"
      [(selection)]="selectedItem"
      [resizableColumns]="true" columnResizeMode="expand"
      (onLazyLoad)="fetchDataViaTableComponent($event)"
      [paginator]="true"
      [first]="gridMeta.lazyLoadMeta?.first ?? 0"
      [rows]="gridMeta.lazyLoadMeta?.rows ?? 20"
      [rowsPerPageOptions]="[10, 20, 50]"
      [paginatorDropdownAppendTo]="'body'"
      [totalRecords]="totalRecords"
      [sortMode]="'multiple'"
      [multiSortMeta]="gridMeta.lazyLoadMeta?.multiSortMeta"
      [filters]="gridMeta.filters!"
      [scrollable]="true" scrollHeight="var(--explorer-grid-height)"
      [tableStyle]="{ 'min-width': '50rem' }"
      styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="mainCategoryName" style="min-width:12rem" pSortableColumn="mainCategoryName" pResizableColumn>
            {{ 'CATEGORY.MAIN' | translate }}
            <p-sortIcon field="mainCategoryName"></p-sortIcon>
            <p-columnFilter type="text" field="mainCategoryName" display="menu" [showOperator]="false"></p-columnFilter>
          </th>
          <th id="subCategoryName" style="min-width:12rem" pSortableColumn="subCategoryName" pResizableColumn>
            {{ 'CATEGORY.SUB' | translate }}
            <p-sortIcon field="subCategoryName"></p-sortIcon>
            <p-columnFilter type="text" field="subCategoryName" display="menu" [showOperator]="false"></p-columnFilter>
          </th>
          <th id="toolCategoryName" style="min-width:14rem" pSortableColumn="toolCategoryName" pResizableColumn>
            {{ 'CATEGORY.TOOL' | translate }}
            <p-sortIcon field="toolCategoryName"></p-sortIcon>
            <p-columnFilter type="text" field="toolCategoryName" display="menu" [showOperator]="false"></p-columnFilter>
          </th>
          <th id="productName" style="min-width:14rem" pSortableColumn="productName" pResizableColumn>
            {{ 'PRODUCT.NAME' | translate }}
            <p-sortIcon field="productName"></p-sortIcon>
            <p-columnFilter type="text" field="productName" display="menu" [showOperator]="false"></p-columnFilter>
          </th>
          <th id="amount" style="min-width:10rem" pSortableColumn="amount" pResizableColumn>
            {{ 'AMOUNT.AMOUNT' | translate }}
            <p-sortIcon field="amount"></p-sortIcon>
            <p-columnFilter type="numeric" field="amount" display="menu" [showOperator]="false"></p-columnFilter>
          </th>
          <th id="fromDate" style="min-width:8rem" pSortableColumn="fromDate" pResizableColumn>
            {{ 'PROJECT.FROMDATE' | translate }}
            <p-sortIcon field="fromDate"></p-sortIcon>
            <p-columnFilter type="date" field="fromDate" display="menu" [showOperator]="false"></p-columnFilter>
          </th>
          <th id="untilDate" style="min-width:8rem" pSortableColumn="untilDate" pResizableColumn>
            {{ 'PROJECT.UNTILDATE' | translate }}
            <p-sortIcon field="untilDate"></p-sortIcon>
            <p-columnFilter type="date" field="untilDate" display="menu" [showOperator]="false"></p-columnFilter>
          </th>
          <th id="active" style="min-width:8rem;text-align: center;" pSortableColumn="active" pResizableColumn>
            {{ 'PROJECT.ACTIVE' | translate }}
            <p-sortIcon field="untilDate"></p-sortIcon>
            <p-columnFilter type="boolean" field="active" display="menu" [showOperator]="false" [showMatchModes]="false">
            <ng-template pTemplate="filterElement" let-value let-filterCallback="filterCallback">
              <div class="flex align-items-center gap-2">
                <button
                  type="button"
                  (click)="filterCallback(true)"
                  class="p-button p-button-success"
                >
                  <i class="pi pi-check"></i>
                </button>
                <button
                  type="button"
                  (click)="filterCallback(false)"
                  class="p-button p-button-danger"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </ng-template>
            </p-columnFilter>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-consumption>
        <tr>
          <td>{{ consumption.mainCategoryName }}</td>
          <td>{{ consumption.subCategoryName }}</td>
          <td>{{ consumption.toolCategoryName }}</td>
          <td>{{ consumption.productName }}</td>
          <td style="text-align: right;">{{ consumption.amount }}</td>
          <td>{{ consumption.fromDate | date: dateFormat }}</td>
          <td>{{ consumption.untilDate | date: dateFormat }}</td>
          <td class="text-center">
            <i *ngIf="consumption.active" class="pi pi-check" style="color: green;"></i>
            <i *ngIf="!consumption.active" class="pi pi-times" style="color: red;"></i>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="text-center bg-fallback">
            <h2 class="mt-3">{{ 'CONSUMPTION.NOT_FOUND' | translate }}</h2>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
